/* ============================================================
   KOVOSIS — Ajax add-to-cart + cart drawer interceptor
   Intercepts #kov-product-form submits, adds via Ajax,
   opens the cart drawer (#kov-cart-drawer) like Dawn default.
   ============================================================ */
(function () {
  'use strict';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- Money formatting (mirrors kovosis-pages.js) ---------- */
  function formatMoney(cents) {
    var fmt = window.KovosisMoneyFormat || '€{{amount}}';
    var a = fmt.indexOf('{{'), b = fmt.indexOf('}}');
    var token = (a !== -1 && b > a) ? fmt.slice(a + 2, b).trim() : 'amount';
    var dec = (token.indexOf('no_decimals') !== -1) ? 0 : 2;
    var thou = ',', deci = '.';
    if (token.indexOf('comma_separator') !== -1) { thou = '.'; deci = ','; }
    else if (token.indexOf('space_separator') !== -1) { thou = ' '; deci = ','; }
    else if (token.indexOf('apostrophe_separator') !== -1) { thou = "'"; deci = '.'; }
    var parts = (cents / 100).toFixed(dec).split('.');
    var intp = parts[0], grouped = '', c = 0;
    for (var i = intp.length - 1; i >= 0; i--) { grouped = intp.charAt(i) + grouped; c++; if (c % 3 === 0 && i > 0) grouped = thou + grouped; }
    var out = parts[1] != null ? grouped + deci + parts[1] : grouped;
    var str = (a !== -1 && b > a) ? fmt.slice(0, a) + out + fmt.slice(b + 2) : out;
    return str;
  }

  /* ---------- Fetch full cart ---------- */
  function fetchCart() {
    return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); });
  }

  /* ---------- Render one cart line item ---------- */
  function renderLineItem(item, index) {
    var img = (item.featured_image && item.featured_image.url) || (item.image) || '';
    var imgAlt = item.product_title || '';
    var title = item.product_title || '';
    var variantTitle = item.variant_title || '';
    var price = formatMoney(item.final_line_price);
    var qty = item.quantity;
    var lineKey = item.key || '';

    return (
      '<div class="kov-cli" data-line="' + (index + 1) + '" data-key="' + lineKey + '">' +
        '<div class="kov-cli__img">' +
          (img ? '<img src="' + img + '" alt="' + imgAlt + '" width="74" height="74" loading="lazy">' : '<div class="kov-cli__ph"></div>') +
        '</div>' +
        '<div class="kov-cli__main">' +
          '<div class="kov-cli__top">' +
            '<p class="kov-cli__name"><a href="' + (item.url || '#') + '">' + title + '</a></p>' +
            '<button type="button" class="kov-cli__rm kov-js-cart-remove" data-key="' + lineKey + '" data-line="' + (index + 1) + '" aria-label="Remove">&times;</button>' +
          '</div>' +
          (variantTitle ? '<p class="kov-cli__cat">' + variantTitle + '</p>' : '') +
          '<div class="kov-cli__row">' +
            '<div class="kov-qty">' +
              '<button type="button" class="kov-js-cart-dec" data-key="' + lineKey + '" data-line="' + (index + 1) + '" aria-label="Decrease">&minus;</button>' +
              '<span>' + qty + '</span>' +
              '<button type="button" class="kov-js-cart-inc" data-key="' + lineKey + '" data-line="' + (index + 1) + '" aria-label="Increase">+</button>' +
            '</div>' +
            '<span class="kov-cli__price">' + price + '</span>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  /* ---------- Render full cart contents into drawer ---------- */
  function renderCart(cart) {
    var itemsEl = $('#kov-cart-items');
    if (!itemsEl) return;
    if (cart.items && cart.items.length > 0) {
      var html = '';
      cart.items.forEach(function (item, i) { html += renderLineItem(item, i); });
      itemsEl.innerHTML = html;
    } else {
      itemsEl.innerHTML = '<p class="kov-cart__empty">Your basket is empty</p>';
    }

    // Update header counts
    var visibleCount = cart.item_count || 0;
    $$('.kov-js-cart-count').forEach(function (el) { el.textContent = visibleCount; });

    // Update subtotal & total
    var subtotalEl = $('#kov-cart-subtotal');
    var totalEl = $('#kov-cart-total');
    var totalFormatted = formatMoney(cart.total_price);
    if (subtotalEl) subtotalEl.textContent = totalFormatted;
    if (totalEl) totalEl.textContent = totalFormatted;

    // Update free-shipping message
    updateShippingMsg(cart.total_price);
  }

  function updateShippingMsg(total) {
    var drawer = $('#kov-cart-drawer');
    if (!drawer) return;
    var threshold = parseInt(drawer.getAttribute('data-free-threshold'), 10);
    var msgEl = $('#kov-cart-ship-msg');
    if (!msgEl || isNaN(threshold) || threshold <= 0) return;
    if (total >= threshold) {
      msgEl.textContent = 'You qualify for free delivery!';
    } else {
      msgEl.textContent = 'Add ' + formatMoney(threshold - total) + ' more for free delivery';
    }
  }

  /* ---------- Open / close drawer ---------- */
  function openDrawer() {
    var drawer = $('#kov-cart-drawer');
    var overlay = $('#kov-overlay');
    if (!drawer) return;
    drawer.hidden = false;
    drawer.style.display = '';
    if (overlay) { overlay.hidden = false; overlay.style.display = ''; }
    // Force reflow then animate
    drawer.offsetHeight;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    var drawer = $('#kov-cart-drawer');
    var overlay = $('#kov-overlay');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    setTimeout(function () {
      drawer.hidden = true;
      if (overlay && !$('#kov-menu-drawer.is-open')) overlay.hidden = true;
    }, 400);
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  /* ---------- Ajax: add to cart ---------- */
  function addToCart(variantId, qty, callback) {
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        renderCart(cart);
        openDrawer();
        if (callback) callback(null, cart);
      })
      .catch(function (err) {
        if (callback) callback(err);
      });
  }

  /* ---------- Ajax: change quantity / remove ---------- */
  function updateCartQuantity(lineKey, line, qty, callback) {
    fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, id: lineKey })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        renderCart(cart);
        if (callback) callback(null, cart);
      })
      .catch(function (err) { if (callback) callback(err); });
  }

  /* ---------- Init ---------- */
  function init() {
    var drawer = $('#kov-cart-drawer');

    // ---- Intercept product form submits (always active, even without drawer) ----
    // Use capture phase so we fire BEFORE <product-form>'s target-phase
    // listener, preventing the double-add that happens when both
    // <product-form> (Ajax) and the native form POST fire.
    document.addEventListener('submit', function (e) {
      var form = e.target;

      // --- Card forms (.kov-card__form) — take full control ---
      if (form.classList.contains('kov-card__form')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var variantInput = form.querySelector('input[name="id"]');
        var variantId = variantInput ? parseInt(variantInput.value, 10) : null;
        if (!variantId) return;
        var qty = 1; // card buttons always add 1
        var addBtn = form.querySelector('.kov-card__add');
        if (addBtn) addBtn.disabled = true;

        addToCart(variantId, qty, function (err) {
          if (addBtn) addBtn.disabled = false;
          if (!err) {
            if (addBtn) addBtn.classList.add('is-added');
            setTimeout(function () {
              if (addBtn) addBtn.classList.remove('is-added');
            }, 2000);
          }
        });
        return;
      }

      // --- Main product form (#kov-product-form) ---
      // Also matches main-product2 forms (product-form2-*) and
      // standard Dawn product forms (product-form-*)
      if (
        form.id !== 'kov-product-form' &&
        !form.closest('#kov-product-form') &&
        form.id.indexOf('product-form2-') !== 0 &&
        form.id.indexOf('product-form-') !== 0
      ) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var variantInput = form.querySelector('#kov-variant-id') || form.querySelector('[id^="kov2-variant-id-"]') || form.querySelector('input[name="id"]');
      var variantId = variantInput ? parseInt(variantInput.value, 10) : null;
      var qtyInput = form.querySelector('#kov-qty') || form.querySelector('[id^="Quantity2-"]') || form.querySelector('input[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (!variantId) return;

      var addBtn = form.querySelector('#kov-add') || form.querySelector('[id^="kov2-add-"]') || form.querySelector('[type="submit"][name="add"]');
      var addText = form.querySelector('#kov-add-text') || form.querySelector('[id^="kov2-add-text-"]') || (addBtn && addBtn.querySelector('span'));
      if (addBtn) addBtn.disabled = true;
      if (addText) addText.textContent = 'Adding…';

      addToCart(variantId, qty, function (err) {
        if (addBtn) addBtn.disabled = false;
        if (!err) {
          if (addBtn) addBtn.classList.add('is-added');
          if (addText) addText.textContent = 'Added!';
          setTimeout(function () {
            if (addBtn) addBtn.classList.remove('is-added');
            if (addText) addText.textContent = window.__kov2AddLabel || window.__kovAddLabel || 'Add to basket';
          }, 2000);
        } else {
          if (addText) addText.textContent = window.__kov2AddLabel || window.__kovAddLabel || 'Add to basket';
        }
      });
    }, true);

    // ---- Also attach directly to any product-form2-* forms on the page ----
    document.querySelectorAll('form[id^="product-form2-"]').forEach(function(f) {
      f.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var variantInput = f.querySelector('[id^="kov2-variant-id-"]');
        var variantId = variantInput ? parseInt(variantInput.value, 10) : null;
        var qtyInput = f.querySelector('[id^="Quantity2-"]');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        if (!variantId) return;
        var addBtn = f.querySelector('[id^="kov2-add-"]');
        var addText = f.querySelector('[id^="kov2-add-text-"]');
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = 'Adding…';
        addToCart(variantId, qty, function(err) {
          if (addBtn) addBtn.disabled = false;
          if (!err) {
            if (addBtn) addBtn.classList.add('is-added');
            if (addText) addText.textContent = 'Added!';
            setTimeout(function() {
              if (addBtn) addBtn.classList.remove('is-added');
              if (addText) addText.textContent = window.__kov2AddLabel || window.__kovAddLabel || 'Add to basket';
            }, 2000);
          } else {
            if (addText) addText.textContent = window.__kov2AddLabel || window.__kovAddLabel || 'Add to basket';
          }
        });
      });
    });

    // ---- Cart-open button (header) ----
    $$('.kov-js-cart-open').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        fetchCart().then(function (cart) { renderCart(cart); openDrawer(); });
      });
    });

    // ---- Close buttons inside drawer ----
    if (drawer) {
    $$('.kov-js-close', drawer).forEach(function (btn) {
      btn.addEventListener('click', closeCartDrawer);
    });
    }

    // ---- Overlay closes drawer ----
    var overlay = $('#kov-overlay');
    if (overlay) {
      overlay.addEventListener('click', function () {
        closeCartDrawer();
        var menuDrawer = $('#kov-menu-drawer');
        if (menuDrawer && menuDrawer.classList.contains('is-open')) {
          menuDrawer.classList.remove('is-open');
          menuDrawer.hidden = true;
        }
      });
    }

    // ---- Quantity & remove buttons (delegated) ----
    if (drawer) {
    drawer.addEventListener('click', function (e) {
      var dec = e.target.closest('.kov-js-cart-dec');
      var inc = e.target.closest('.kov-js-cart-inc');
      var rem = e.target.closest('.kov-js-cart-remove');

      if (dec) {
        var span = dec.parentElement && dec.parentElement.querySelector('span');
        var current = span ? parseInt(span.textContent, 10) || 1 : 1;
        var newQty = Math.max(1, current - 1);
        updateCartQuantity(dec.dataset.key, parseInt(dec.dataset.line, 10), newQty);
      }
      if (inc) {
        var span = inc.parentElement && inc.parentElement.querySelector('span');
        var current = span ? parseInt(span.textContent, 10) || 1 : 1;
        var newQty = current + 1;
        updateCartQuantity(inc.dataset.key, parseInt(inc.dataset.line, 10), newQty);
      }
      if (rem) {
        updateCartQuantity(rem.dataset.key, parseInt(rem.dataset.line, 10), 0);
      }
    });

    // ---- Escape key closes drawer ----
    document.addEventListener('keydown', function (e) {
      if (drawer && e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeCartDrawer();
      }
    });

    // ---- Initial render from server cart ----
    fetchCart().then(function (cart) { if (drawer) renderCart(cart); }).catch(function () {});
    } // end if (drawer)
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
